import { render, staticRenderFns } from "./FormatView.vue?vue&type=template&id=49cf2516&scoped=true&"
import script from "./FormatView.vue?vue&type=script&lang=ts&"
export * from "./FormatView.vue?vue&type=script&lang=ts&"
import style0 from "./FormatView.vue?vue&type=style&index=0&id=49cf2516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cf2516",
  null
  
)

export default component.exports